import { action, makeObservable, observable, reaction } from 'mobx';
import { UiStore } from './ui';
import { appConfig } from '../settings';
import { IFilterParams, ISelect, IUsersList } from '../interfaces';
import { getUsersList } from '../middleware';
import { apiParamsCleaner } from '../instruments';

export class UsersStore {
    private constructor() {
        makeObservable(this);
        reaction(
            () => this.forcedUpdateTime,
            () => {
                const UiStoreInstance = UiStore.getInstance();
                const params = UiStoreInstance.params;
                const cleanParams = apiParamsCleaner(params, this.filterParams);
                getUsersList(cleanParams).then();
            },
            {
                delay: appConfig.APIDelay,
            },
        );
    }

    private static instance: UsersStore;
    public static getInstance(): UsersStore {
        if (!UsersStore.instance) {
            UsersStore.instance = new UsersStore();
        }
        return UsersStore.instance;
    }

    @observable select: ISelect[] = [];
    @observable totalSelect = 0;
    @action setUsersSelect(list: ISelect[], totalSelect = 0): void {
        this.select = list;
        this.totalSelect = totalSelect;
    }

    @observable list: IUsersList = [];
    @action setUsersList(list: IUsersList): void {
        this.list = list;
    }

    @action cleanStore(): void {
        this.list = [];
        this.select = [];
        this.totalSelect = 0;
    }

    @observable forcedUpdateTime = 0;
    @action setForcedUpdateTime(): void {
        this.forcedUpdateTime = Date.now();
    }

    @observable filterParams: IFilterParams = {
        pageNumber: true,
        pageSize: true,
        search: true,
        companyId: true,
    };
}
